import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import { getImage } from '@utils/imageHelper';

const EMPTY_STATE_ILLUSTRATION = getImage(
  'test-series-listing/empty-state-spot.svg'
);

const EmptyStateContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${Spacings.SPACING_4B};
  width: 100%;
  max-width: 852px;
  min-height: inherit;
  padding: ${Spacings.SPACING_8B};
  box-sizing: border-box;
  border-radius: 8px;
  background: var(--color-i-white);

  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_4B};
  }
`;

const Illustration = styled.img`
  width: 80px;
  height: 80px;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 20px;
  line-height: 28px;
  font-weight: ${Fonts.SEMIBOLD};
  color: #3c4852;
  text-align: center;

  ${mediaQuery.uptoMobile} {
    line-height: 24px;
  }
`;

const Subtitle = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  font-weight: ${Fonts.REGULAR};
  color: #7a8b94;
  text-align: center;

  ${mediaQuery.uptoMobile} {
    line-height: 20px;
  }
`;

const TestSeriesListingEmptyState = ({ title, description }) => (
  <EmptyStateContainer role="status">
    <Illustration src={EMPTY_STATE_ILLUSTRATION} alt="" aria-hidden="true" />
    <Title>{title}</Title>
    <Subtitle>{description}</Subtitle>
  </EmptyStateContainer>
);

export default TestSeriesListingEmptyState;

TestSeriesListingEmptyState.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string
};

TestSeriesListingEmptyState.defaultProps = {
  title: 'No test found',
  description: "There's no test scheduled for this day"
};
